// routes
export const HOME_ROUTE = '/';
export const CREATE_INSPIRATIONS_ROUTE = '/image-gen/';
export const BRUSH_TOOL_ROUTE = '/magic-tool/';
export const CREATE_INSPIRATIONS_WITH_ID_ROUTE = '/image-gen/:id';


// api routes
export const ROOT_API = "https://stag4.imagine.io"; // "https://prod.imagine.io";
export const ENVIRONMENT = ROOT_API === "https://prod.imagine.io" ? "production" : "staging";
export const USER_DETAILS_API = "/users/api/v3/user-details/";
export const GET_IMAGE_API = "/aiimages/api/details/";
export const SAVE_IMAGE_API = "/aiimages/api/bulk-create/";

const FRONTEND_BASE_URL  = "https://inhouse.imagine.io/"
export const LOGIN_URL = `${FRONTEND_BASE_URL}sign-in?referrer=/ai`;
export const ALL_GENERATIONS_URL = `${FRONTEND_BASE_URL}my-files/imagine-ai`;

export const USER_DETAILS_API_URL = ROOT_API + USER_DETAILS_API;
export const GET_IMAGE_API_URL = ROOT_API + GET_IMAGE_API;
export const SAVE_IMAGE_API_URL = ROOT_API + SAVE_IMAGE_API;

export const CURRENT_USER = "current_user";

export const LF_DEBUGGER = "lf_debugger";
export const LF_DEBUGGER_MIXPANEL_TRACKING = "LF_DEBUGGER_MIXPANEL_TRACKING";
export const LF_DEBUGGER_HUBSPOT = "LF_DEBUGGER_HUBSPOT";
export const RESTRICTED_EMAILS = [
  "imagine.io",
  "livefurnish.com",
  "taglineinfotech",
  "tagline",
  "algoworks",
  "zedinteractive",
];

export const TOOLS = {
    bgRemoval:"bg_removal",
    inspirationGeneration:"inspiration_generation",
    productBackgroundGeneration:"product_background_generation",
    magicTool:"magic_tool",
}

export const IMAGINE_DISCORD_CHANNEL = "https://discord.gg/9Kn9Npum"
export const IMAGINE_INSTAGRAM_CHANNEL = "https://www.instagram.com/channel/AbZe4HdjSzNslbmi/"